import types from './mutations-types';
import { NavigationStateShape } from 'store';
import { MutationTree } from 'vuex';

export default {
	[types.SET_NAVIGATION_TREE](state: NavigationStateShape, navigationTree = {}) {
		state.navigationTree = navigationTree;
	},

	[types.SET_NAVIGATION_DATA](state: NavigationStateShape, navigationData = {}) {
		state.navigationData = navigationData;
	},

	[types.SET_SEARCH_FILTER](state: NavigationStateShape, filter = '') {
		state.filter = filter;
	},

	[types.UPDATE_NAVIGATION_ITEM](state: NavigationStateShape, { id, data }) {
		const item = state?.navigationData[id];

		if (item) {
			state.navigationData[id] = Object.assign({}, item, data);
		}
	}
} as MutationTree<NavigationStateShape>;
